import React, { useCallback, useMemo } from 'react';
import { ReactComponent as ChevronLeftIcon } from 'assets/svg/2_arrow_left.svg';
import { ReactComponent as ChevronRightIcon } from 'assets/svg/2_arrow_right.svg';
import styles from 'css_modules/Pagination.module.css';
import { Select } from './Select';

export const Pagination = ({ user, docs, setPage, limit, setLimit,setClicked, canPrev=true, canNext=true }) => {
    const { current, last, count } = docs;

    const limits = useMemo(
        () => [10, 20, 30, 40, 50, 100, 200].map(v => ({ id: v, title: v })),
        []
    );
    
    const changeLimit = useCallback(
        (e) => {
            const value = Number(e.target.value);
            localStorage.setItem(`limit${user.pk}`, value);
            setLimit(value);
            setPage(1);
            setClicked("clickedreset")
        },
        [setLimit, setPage, user.pk,setClicked]
    );

    const goTo = useCallback(
        (page) => () => {
            setPage(page);
        },
        [setPage]
    );

    const goToCursorNext = useCallback(
        (page) => () => {
            setClicked("clickednext")
        },
        [setClicked]
    );
    const goToCursorPrevious = useCallback(
        (page) => () => {
            setClicked("clickedprevious")
        },
        [setClicked]
    );


    const pageWindow = useMemo(() => {
        const windowSize = 5;
        const half = Math.floor(windowSize / 2);

        let start = current - half;
        let end = current + half;

        if (start < 1) {
            start = 1;
            end = Math.min(windowSize, last);
        }

        if (end > last) {
            end = last;
            start = Math.max(1, last - windowSize + 1);
        }

        const pages = [];

        for (let p = start; p <= end; p++) {
            const isCurrent = p === current;
            
            pages.push(
                <button
                    key={p}
                    
                    onClick={!isCurrent ? goTo(p) : undefined}
                    className={isCurrent ? styles.current : styles.button}
                >
                    {p}
                </button>
            );
        }

        return pages;
    }, [current, last, goTo]);
    
    const displayLimit = limit > count ? count : limit;

    const limitsWithCount =
    limit > count && !limits.some(l => l.id === count)
        ? [...limits, { id: count, title: count }]
        : limits;


    let cursorPagination = user.toggle_new_pagination
  
    
    if (cursorPagination===false){

        return (
            <div className={styles.wrapper}>
                <div className={styles.paginationDiv}>
                    <div className={styles.paginationPager}>
                        <span>Zobrazit</span>
                    <Select
                        name="limit_select"
                        data={limitsWithCount} 
                        value={displayLimit} 
                        onChange={changeLimit}
                        notNull
                        className={styles.paginator}
                        dropUp
                    />
                        <p className={styles.paginationPar}>z {count}</p>
                    </div>
                </div>

                <div className={styles.pagination}>
                    <button
                        disabled={current === 1}
                        onClick={goTo(1)}
                        className={`${styles.button} ${styles.firstButton}`}
                    >
                        První
                    </button>

                    <button
                        disabled={current === 1}
                        onClick={goTo(current - 1)}
                        className={styles.button}
                    >
                        <ChevronLeftIcon className={current === 1?styles.arrowDisabled:styles.arrow} />
                    </button>

                    <div className={styles.pageNumbers}>
                        {pageWindow}
                    </div>

                    <button
                        disabled={current === last}
                        onClick={goTo(current + 1)}
                        className={styles.button}
                    >
                        <ChevronRightIcon  className={current === last?styles.arrowDisabled:styles.arrow} />
                    </button>

                    <button
                        disabled={current === last}
                        onClick={goTo(last)}
                        className={`${styles.button} ${styles.lastButton}`}
                    >
                        Poslední
                    </button>
                </div>
            </div>
        );
        }
    else{
        return (
            <div className={styles.wrapper}>
                <div className={styles.paginationDiv}>
                    <div className={styles.paginationPager}>
                        <span>Zobrazit</span>
                    <Select
                        name="limit_select"
                        data={limitsWithCount} 
                        value={displayLimit} 
                        onChange={changeLimit}
                        notNull
                        className={styles.paginator}
                        dropUp
                    />
                     
                    </div>
                </div>

                <div className={styles.pagination}>
                   
                    <button
                        disabled={!canPrev}
                        onClick={goToCursorPrevious()}
                        className={styles.button}
                    >
                        <ChevronLeftIcon className={(!canPrev)?styles.arrowDisabled:styles.arrow} />
                    </button>

                    <div className={styles.pageNumbers}>
                        {pageWindow}
                    </div>


                    <button
                        disabled={!canNext}
                        onClick={goToCursorNext()}
                        className={styles.button}
                    >
                        <ChevronRightIcon  className={!canNext?styles.arrowDisabled:styles.arrow} />
                    </button>

                </div>
            </div>
        );
    }
};
